export default {
  install(Vue) {
    Vue.prototype.$alert = function (title, type, extraConfig = {}) {
      return this.$root.$emit("alert", { title, type, ...extraConfig });
    };
  },
};
